import React from "react";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { Amenity, AmenityStatus } from "@b2bportal/lodging-api";
import { CheckboxGroup } from "@tenant/ui";
import defaultStyles from "./FilterAmenities.module.scss";

export interface FilterAmenityProps extends PlatformComponentProps {
  selectedValues: Amenity[];
  onChange: (values: Amenity[]) => void;
  options: AmenityStatus[];
}
export const FilterAmenities = ({
  selectedValues,
  onChange,
  options,
  children,
}: FilterAmenityProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.FilterAmenity,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.FilterAmenity);

  const getAmenityLabel = (amenity: AmenityStatus) => amenity.displayName;

  const items = options.map((amenity) => ({
    label: getAmenityLabel(amenity),
    value: amenity.amenity,
  }));

  return (
    <div className={block}>
      <CheckboxGroup
        options={items}
        checkedOptions={selectedValues}
        onOptionsChange={onChange}
      />
      {children}
    </div>
  );
};
